<template>
  <div class="right-content">
    <!-- 邮件营销 -->
    <EmailMarketing v-if="systemCode === 'ERP'"></EmailMarketing>

    <!-- 资金助手 -->
    <a-tooltip :title="i18nRender('layouts.MoneyAssistant')" v-if="isAppear">
      <a class="right-content__action" @click="toMoneyAssistant">
        <icon-font type="gb-icon-daohang-tubiao-zijinzhushou"  style="color: white;" />
      </a>
    </a-tooltip>

    <!-- 消息提醒 -->
    <news-list v-if="!isDemo"></news-list>

    <!-- 系统切换 -->
    <!-- !isDemo && subjectMode !== 1 -->
    <system-change v-if="!isDemo" :systems="systems"></system-change>

    <!-- 菜单变身 ** 只有ERP进来才有 -->
    <menu-transform v-if="systemCode === 'ERP'"></menu-transform>

    <!-- 版本切换 -->
    <!-- !isDemo && subjectMode !== 1 && useNewMenu === 1 && Number(currentSystem.subTab) < 6 && systemCode === 'ERP' -->
    <version-change
      v-if="!isDemo && useNewMenu === 1 && Number(currentSystem.subTab) < 6 && systemCode === 'ERP'"
    ></version-change>

    <!-- 帮助中心 -->
    <!-- <a-tooltip :title="i18nRender('layouts.helpcenter')" v-if="useNewMenu === 1">
      <a class="right-content__action" v-demo="'openHelpCenter'">
        <icon-font type="gb-icon-helper-circle" />
      </a>
    </a-tooltip>-->

    <!-- 客服系统 -->
    <a-tooltip :title="i18nRender('layouts.onlineservice')">
      <a class="right-content__action" href="javascript:;" v-demo="'getQueryList'">
        <icon-font type="gb-icon-customer-service-2" />
      </a>
    </a-tooltip>

    <!-- 语言切换 -->
    <select-lang />

    <!-- 用户信息 -->
    <avatar-dropdown />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import EmailMarketing from './EmailMarketing'
// import MoneyAssistant from './MoneyAssistant'
import AvatarDropdown from './AvatarDropdown.next'
import SelectLang from './SelectLang'
import NewsList from './NewsList'
import VersionChange from './VersionChange'
import SystemChange from './SystemChange'
import MenuTransform from './MenuTransform'
import { i18nRender } from '@/locales'
import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types'
import { querySystemExtListForSub, QuerySystemParamsPage, forward } from '@/api'
import { findPane } from '@/store/_util/util'

export default {
  name: 'RightContent',
  components: {
    AvatarDropdown,
    SelectLang,
    NewsList,
    VersionChange,
    SystemChange,
    MenuTransform,
    EmailMarketing
    // MoneyAssistant
  },
  props: {
    subjectMode: {
      type: [Number, Object],
      default: () => null
    }
  },
  data () {
    const userInfo = this.$ls.get(USER_INFO)
    return {
      userInfo,
      systems: [],
      currentSystem: {},
      url: '',
      isFlag: false,
      MoneyAssistantUrl: '',
      isAppear: false
    }
  },
  computed: {
    ...mapGetters([
      'serviceId',
      'systemCode',
      'useNewMenu',
      'isDemo',
      'microApps',
      'panes',
      'menus',
      'activeKey'
    ])
    // isERP () {
    //   return this.microApps.find(item => item.systemCode === 'ORDER_MANAGER')
    // }
  },
  methods: {
    i18nRender,
    async getQueryList () {
      const { systemCode } = this.$route.params
      try {
        const params = {
          paging: false,
          systemGroup: 'ECS_CUSTOMER_CONFIG'
        }
        const { dataList } = await QuerySystemParamsPage(params)
        dataList.forEach((v) => {
          if (v.status === 2 && v.systemName === systemCode) {
            this.isFlag = true
            this.url = v.systemValue
          }
        })
        if (this.isFlag) {
          this.openSale1()
        } else {
          this.openSaleConsult()
        }
      } catch (error) {
        console.log(error)
      }
    },
    openSale1 () {
      let menuName = '' // 当前的页面名称
      // console.log(this.panes)
      this.panes.forEach((v, i) => {
        if (v.key === this.activeKey) {
          menuName = v.tab
        }
      })
      const params = {
        token: this.$ls.get(ACCESS_TOKEN),
        menuId: this.activeKey,
        menuName
      }
      const found = findPane(this.menus, { key: this.activeKey }, null, ['systemCode'])

      if (found && typeof (found.systemCode) !== 'undefined') {
        params.systemCode = found.systemCode
      }

      const URL = `${this.url}?${Object.keys(params).map((key) => `${key}=${params[key]}`).join('&')}`
      // console.log(URL)
      window.open(URL, '_blank')
    },
    openSaleConsult () {
      const { systemCode } = this.$route.params
      this.$store.dispatch('OpenSaleConsult', systemCode)
    },
    openHelpCenter () {
      const { systemCode } = this.$route.params
      window.open(`/#/company/helper/center?helpSystemCode=${systemCode}`)
    },
    toMoneyAssistant () {
      window.open(this.MoneyAssistantUrl, '_blank')
    }
  },
  mounted () {
    querySystemExtListForSub({
      paging: false,
      serviceCode: 'ERP+'
    }).then(({ dataList }) => {
      this.systems = dataList[0].serviceInfoExt
        // .filter(
        //   (item) => item.serviceDeploy === 4 && [2, 4].includes(item.status)
        // )
        .map((item) => {
          if (item.systemName === 'Amazon 运营') {
            item.systemName = '运营'
          }
          return item
        })
      this.currentSystem = this.systems.find((item) => item.systemCode === this.systemCode) || {}
    })
    forward({}).then(res => {
      if (res.data) {
        const data = JSON.parse(res.data.respBody)
        this.MoneyAssistantUrl = data.url || ''
        if (data.authStatus === 1) {
          this.isAppear = true
        }
      }
    })
  }
}
</script>

<style lang="less">
.right-content {
  margin-right: 0px;
  display: inline-flex;
  height: 42px;
  line-height: 42px;

  &__action {
    padding: 0 11px;
    display: inline-flex;
    color: #ffffff;
    font-size: 12px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.3s;
    align-items: center;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      color: #40a9ff;
    }

    > span {
      padding-right: 11px;
      display: inline-block;
      max-width: 8em;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: bottom;
    }

    .anticon {
      font-size: 1.3em;
      vertical-align: middle;
    }
  }
}
</style>
